// extracted by mini-css-extract-plugin
export default {"modalTitle":"style_modalTitle__uPpsu","actionButton":"style_actionButton__JZiOZ","cancelButton":"style_cancelButton__71IFJ","deleteButton":"style_deleteButton__6ENKc"};